import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';

import {
  buildQuerySetQueryReducerType,
  buildQuerySetIsFormsButtonsEnabledReducerType,
  buildQuerySetIsClassicLicenseReducerType,
  buildQuerySetStructurePreviewReducerType,
  buildQuerySetPreviewSizeReducerType,
  buildQuerySetDbsReducerType,
  buildQuerySetQsFormsReducerType,
  buildQueryResetStateReducerType,
} from './BuildQueryConstants';

export const initialState = Map({
  query: {
    text: '',
    Typeaheads: [],
  },
  isFormsButtonsEnabled: false,
  isClassicLicense: false,
  structurePreview: null,
  previewSize: null,
  dbs: [],
  qsForms: [],
});

const spec = {
  [buildQuerySetQueryReducerType]: (state, action) => {
    const { query } = action.payload;
    return state.set('query', query);
  },
  [buildQuerySetIsFormsButtonsEnabledReducerType]: (state, action) => {
    const { isFormsButtonsEnabled } = action.payload;
    return state.set('isFormsButtonsEnabled', isFormsButtonsEnabled);
  },
  [buildQuerySetIsClassicLicenseReducerType]: (state, action) => {
    const { isClassicLicense } = action.payload;
    return state.set('isClassicLicense', isClassicLicense);
  },
  [buildQuerySetStructurePreviewReducerType]: (state, action) => {
    const { structurePreview } = action.payload;
    return state.set('structurePreview', structurePreview);
  },
  [buildQuerySetPreviewSizeReducerType]: (state, action) => {
    const { previewSize } = action.payload;
    return state.set('previewSize', previewSize);
  },
  [buildQuerySetDbsReducerType]: (state, action) => {
    const { dbs } = action.payload;
    return state.set('dbs', dbs);
  },
  [buildQuerySetQsFormsReducerType]: (state, action) => {
    const { qsForms } = action.payload;
    return state.set('qsForms', qsForms);
  },
  [buildQueryResetStateReducerType]: () => {
    return initialState;
  },
};

export default createReducerBySpec(spec, initialState);
